const breakNews = [
  { label: "头条实锤", text: "狗仔两晚直击沈星野林眠同回公寓", time: "刚刚" },
  { label: "官宣分手", text: "影后苏蔓发文结束六年感情，措辞体面", time: "3分钟前" },
  { label: "约会实锤", text: "陈屿深夜与神秘女子共进晚餐被拍", time: "26分钟前" },
];

export default function Hero() {
  return (
    <section id="home" className="relative w-full overflow-hidden">
      <div className="mx-auto max-w-7xl px-4 md:px-6 pt-8 md:pt-12 pb-10 md:pb-14 grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-8 items-start">
        {/* 左：主头条 */}
        <div className="lg:col-span-8 flex flex-col">
          <div className="flex items-center gap-2 mb-4 flex-wrap">
            <span className="inline-flex items-center gap-1 bg-primary-600 text-background-50 text-xs font-medium rounded px-2.5 py-1">
              <i className="ri-hotspot-line"></i> 本日头条
            </span>
            <span className="inline-flex items-center gap-1 bg-accent-100 text-accent-900 text-xs font-medium rounded px-2.5 py-1">
              <i className="ri-calendar-event-line"></i> 今日瓜料 06 条
            </span>
          </div>

          <p className="font-heading text-accent-600 tracking-wide text-sm mb-2">MELON HOT · 恋情感瓜速递</p>
          <h1 className="font-heading text-3xl md:text-5xl font-black leading-snug text-foreground-950">
            沈星野 · 林眠 <span className="text-primary-600">同回公寓被连续实锤</span>
          </h1>
          <p className="mt-4 text-base md:text-lg leading-relaxed text-foreground-700 max-w-2xl">
            狗仔连续两晚直击两人同返某高档公寓，从车接车送到电梯同行细节逐一被记录。这段从合作期便蔓延的绯闻，似乎正在一步步走向「实锤」。绯闻瓜田为你完整梳理来龙去脉。
          </p>

          <div className="mt-6 flex flex-wrap items-center gap-3">
            <a href="#gossip" className="whitespace-nowrap inline-flex items-center gap-2 rounded-md bg-primary-600 text-background-50 px-5 h-10 font-medium text-sm hover:bg-primary-700 transition-colors">
              查看完整瓜料 <i className="ri-arrow-right-line"></i>
            </a>
            <a href="#timeline" className="whitespace-nowrap inline-flex items-center gap-2 rounded-md bg-background-100 text-foreground-800 px-5 h-10 font-medium text-sm hover:bg-primary-100 transition-colors">
              <i className="ri-focus-3-line text-primary-600"></i> 回溯绯闻全记录
            </a>
          </div>

          <div className="mt-7 flex items-center gap-3 text-xs text-foreground-500 flex-wrap">
            <span className="inline-flex items-center gap-1.5">
              <i className="ri-eye-line"></i> 讨论热度 185.6万
            </span>
            <span className="inline-flex items-center gap-1.5">
              <i className="ri-time-line"></i> 更新于 2小时前
            </span>
            <span className="inline-flex items-center gap-1.5">
              <i className="ri-shield-check-line"></i> 已核实来源
            </span>
          </div>
        </div>

        {/* 右：热搜滚动头条 */}
        <aside className="lg:col-span-4 flex flex-col gap-3" aria-label="最新娱乐八卦头条速递">
          <div className="bg-foreground-950 text-background-50 rounded-lg p-5">
            <div className="flex items-center justify-between mb-4">
              <h3 className="font-heading text-lg font-bold text-background-50">最新瓜讯</h3>
              <span className="inline-flex items-center gap-1.5 text-xs text-accent-300">
                <i className="ri-refresh-line"></i> 实时更新
              </span>
            </div>
            <ul className="flex flex-col">
              {breakNews.map((item) => (
                <li key={item.text} className="flex flex-col gap-1.5 py-3 border-b border-background-50/10 last:border-0">
                  <div className="flex items-center gap-2 flex-wrap">
                    <span className="text-[11px] font-medium text-accent-300 whitespace-nowrap">{item.label}</span>
                    <span className="text-[11px] text-background-300 whitespace-nowrap">{item.time}</span>
                  </div>
                  <a href="#gossip" className="text-sm leading-snug text-background-100 hover:text-accent-200 transition-colors">
                    {item.text}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="relative rounded-lg overflow-hidden h-44 md:h-52">
            <img
              src="https://readdy.ai/api/search-image?query=editorial%20paparazzi%20photography%20of%20two%20stylish%20silhouetted%20celebrities%20walking%20together%20toward%20a%20modern%20apartment%20at%20night%2C%20candid%20street%20shot%2C%20warm%20amber%20street%20lights%2C%20film%20grain%2C%20gossip%20magazine%20cover%20mood%2C%20cinematic&width=700&height=420&seq=hero-side&orientation=landscape"
              alt="沈星野与林眠深夜同返公寓的娱乐八卦街拍画面"
              className="absolute inset-0 w-full h-full object-cover object-top"
              loading="eager"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent"></div>
            <div className="absolute bottom-0 left-0 right-0 p-4">
              <p className="text-background-50 text-sm font-medium">沈星野 · 林眠 深夜被拍画面直击</p>
            </div>
          </div>
        </aside>
      </div>
    </section>
  );
}